import { AxiosResponse } from 'axios';
import axiosInstance, { HT_API_ROUTES } from '@/lib/http/hypertrackerHttpRequest';

export interface UsageMetrics {
    used: number;
    remaining: number;
    limit: number;
}

export interface Usage {
    perMinute: UsageMetrics;
    daily?: UsageMetrics;
    monthly?: UsageMetrics;
}

export interface RateLimit {
    capacity: number;
    availableCapacity: number;
    refillPeriodSeconds: number;
}

export interface RequestUsage {
    currentMinute: number;
    currentDay: number;
    currentMonth: number;
}

export interface Token {
    availableUnits: string;
    grantedUnits: string;
    usedUnits: string;
    expiresAt: string;
}

export interface Subscription {
    id: number;
    mid: number;
    consumerId: number;
    planId: number;
    effectiveAt: string;
    expireAt: string;
    source: string | null;
    sourceId: string | null;
    createdAt: string;
    updatedAt: string | null;
    deactivatedAt: string | null;
}

export interface PlanEndpointLimit {
    req_per_minutes: number;
}

export interface Plan {
    id: number;
    name: string;
    dailyRequests: number | null;
    monthlyRequests: number | null;
    monthlyCreditUnits: string;
    dailyCreditUnits: string;
    requestsPerMinute: number;
    webhooksAllowed: boolean;
    websocketsAllowed: boolean;
    lookbackHours: Record<string, unknown> | null;
    endpointLimits: Record<string, PlanEndpointLimit>;
}

export interface ConsumerDataResponse {
    accessToken: string;
    id: string;
    mid: number;
    name: string;
    consumerId: number;
    createdAt: string;
    updatedAt: string;
    subscription: Subscription;
    plan: Plan;
    usage: Usage;
    rateLimit: RateLimit;
    requestUsage: RequestUsage;
    tokens: Token;
    webhook: WebhookConfig | null;
}

export interface CreateConsumerTokenResponse {
    accessToken: string;
}

export interface WebhookConfig {
    url: string;
    bearerToken: string | null;
    events: string[];
    active: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface WebhookBody {
    url: string;
    bearerToken: string | null;
}

export const createConsumer = (): Promise<AxiosResponse<ConsumerDataResponse>> =>
    axiosInstance.post(HT_API_ROUTES.CONSUMER.CREATE_SLASH);

export const createConsumerToken = (): Promise<AxiosResponse<CreateConsumerTokenResponse>> =>
    axiosInstance.post(HT_API_ROUTES.CONSUMER.TOKEN_SLASH);

export const saveConsumerWebhook = (body: WebhookBody): Promise<AxiosResponse<WebhookConfig>> =>
    axiosInstance.put(HT_API_ROUTES.CONSUMER.WEBHOOK_SLASH, body);

export const deleteConsumerWebhook = (): Promise<AxiosResponse<void>> =>
    axiosInstance.delete(HT_API_ROUTES.CONSUMER.WEBHOOK_SLASH);
